import { MODAL_CREATE_CONTENT_GROUP } from "fleet/constant/media-library";
import { MEDIA_LIBRARY_OPEN_MODAL } from "fleet/redux-store/ui-state/media-library";
import reduceReducers from "reduce-reducers";
import {
  UPLOAD_USER_CONTENT,
  UPLOAD_USER_CONTENT_ERROR,
  UPLOAD_USER_CONTENT_SUCCESS,
} from "redux-store/user-contents/actions";

import {
  CONTENT_GROUP_FORM_UPDATE_CONTENT,
  CONTENT_GROUP_FORM_UPDATE_NAME,
} from "./actions";

const initialState = {
  content: [],
  hasUploadError: false,
  isUploading: false,
  name: "",
};

function updateReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CONTENT_GROUP_FORM_UPDATE_CONTENT:
      return {
        ...state,
        content: [...payload],
      };
    case CONTENT_GROUP_FORM_UPDATE_NAME:
      return {
        ...state,
        name: payload,
      };
    default:
      return state;
  }
}

function uploadContentReducer(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_USER_CONTENT:
      return {
        ...state,
        hasUploadError: false,
        isUploading: true,
      };
    case UPLOAD_USER_CONTENT_ERROR:
      return {
        ...state,
        hasUploadError: true,
        isUploading: false,
      };
    case UPLOAD_USER_CONTENT_SUCCESS:
      return {
        ...state,
        hasUploadError: false,
        isUploading: false,
        content: [...state.content, action.payload.data],
      };
    default:
      return state;
  }
}

function modalReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MEDIA_LIBRARY_OPEN_MODAL:
      return {
        ...(payload === MODAL_CREATE_CONTENT_GROUP ? initialState : state),
      };
    default:
      return state;
  }
}

const contentGroupFormReducer = reduceReducers(
  modalReducer,
  updateReducer,
  uploadContentReducer,
);
export { contentGroupFormReducer };
